<template>
  <div class="cominfo">
    <div class="account-user">
      <el-breadcrumb separator="/" class="bc-nav">
        <el-breadcrumb-item :to="{ path: '/companyInfo' }">企业资料</el-breadcrumb-item>
        <el-breadcrumb-item>企业认证</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tips-con" id="auto-0" v-if="!certificateInfo.cancelUpdateFlag">
      <template v-if="certificateInfo.certificateStatus === 5 || certificateInfo.certificateStatus === 6">
        <span @click="handleToUpdateInfo" class="pointer"> {{ certificateInfo.certificateStatusResult }}></span>
      </template>
      <template v-else>
        {{ certificateInfo.certificateStatusResult }}
      </template>
    </div>
    <div class="segment-outer">
      <div class="segment statistics">
        <div class="segment-header">管理员认证</div>
        <div class="segment-area segment-item-box">
          <div class="segment-item">
            <span class="name">管理员姓名： </span>
            <span class="dec" id="auto-1">{{ certificateInfo.managerName }}</span>
            <span
              id="auto-2"
              @click="handleSetAdmin"
              class="font-blue ml-10 pointer"
              v-if="
                certificateStatus !== 99 &&
                certificateStatus !== 1 &&
                certificateStatus !== 3 &&
                certificateStatus !== 5
              "
              >更换管理员</span
            >
          </div>
          <div class="segment-item">
            <span class="name">管理员身份证号： </span>
            <span class="dec" id="auto-3">{{ certificateInfo.identityCard | filterIdcard(1, 1) }}</span>
          </div>
          <div class="segment-item">
            <span class="name">实名认证： </span>
            <div class="rz-title" id="auto-4">
              <div v-if="!accountCertificateStatus">
                <i class="un-certify"></i>
                <span class="red"> 未认证 </span>
              </div>
              <div v-else>
                <i class="certify"></i>
                <span class="font-green">已认证</span>
              </div>
            </div>
          </div>
          <div class="segment-item" id="auto-5">
            <span class="name">管理员是否是法人本人： </span>
            <div v-if="certificateStatus === 99 || certificateStatus === 0">
              <span class="dec">未设置 </span>
            </div>

            <div v-if="certificateStatus !== 99 && certificateStatus !== 0">
              <span class="dec" v-if="isCorp">管理员是法人本人 </span>
              <span class="dec" v-if="!isCorp">管理员不是法人本人 </span>
            </div>
          </div>
          <div class="segment-item">
            <span class="name">企业委托书：</span>
            <template v-if="isCorp" id="auto-6">
              <span class="dec">无需上传 </span>
            </template>
            <template v-if="!isCorp" id="auto-7">
              <div v-if="certificateStatus == 0 || certificateStatus == 99">
                <span class="dec">未上传 </span>
                <span class="dec font-blue pointer" @click="handleDownload">点击下载模板 </span>
              </div>
              <div v-if="certificateStatus == 1 || certificateStatus == 3 || certificateStatus == 5">
                <span class="dec font-blue pointer" @click="handleView">查看 </span>
              </div>
              <div v-if="certificateStatus == 2 || certificateStatus == 4 || certificateStatus == 6">
                <span class="dec font-blue pointer" @click="handleView">查看 </span>
                <span class="dec font-blue pointer" @click="handleDownload">点击下载模板 </span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-group ml-20 mt-20 mb-20 pl-20">
      <el-button v-if="certificateStatus == 99" type="primary" @click="handleSetAdmin" id="auto-8">安全升级</el-button>
      <el-button
        v-if="certificateStatus == 0 || certificateStatus == 4"
        type="primary"
        id="auto-9"
        @click="hanldeUpload"
        >上传委托书</el-button
      >
      <el-button v-if="certificateStatus == 2" type="primary" id="auto-10" @click="hanldeUpload"
        >重新上传委托书</el-button
      >
      <el-button
        v-if="certificateStatus == 3 || (certificateStatus == 6 && certificateInfo.cancelUpdateFlag)"
        type="primary"
        @click="handleSetAdmin"
        id="auto-11"
        >更换管理员</el-button
      >
    </div>

    <!--上传委托书-->
    <el-dialog :visible.sync="uploadTip" title="上传委托书" custom-class="tip-dialog">
      <div class="segment-item top">
        <span class="name short">企业委托书：</span>
        <div>
          <span class="dec font-blue download pointer" @click="handleDownload">点击下载模板 </span>
          <upLoad-single-pic
            currentImgName="engagementLetterUrl"
            :currentImgVal="engagementLetterUrl"
            @succeed="handleLoadSucceed"
            @remove="handleRemoved"
          >
            <template slot="upload-tip">
              <div class="el-upload__tip">上传委托书照片</div>
            </template>
          </upLoad-single-pic>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" :disabled="!engagementLetterUrl" @click="handleUploadLetter">确定</el-button>
      </div>
    </el-dialog>

    <!--短信验证-->
    <el-dialog
      :visible.sync="validPhoneTip"
      title="查看委托书"
      custom-class="tip-dialog"
      :before-close="handleCloseValidPhoneTip"
    >
      <div class="send-box">
        <div class="send-item">
          <span class="name">手机号</span>
          <span class="dec">{{ userPhone }}</span>
          <el-button @click="getCode" class="code-btn" :disabled="countdown.issend">
            <span v-if="countdown.issend" class="sen-dec">{{ countdown.second }}s</span>
            <span v-else>获取验证码</span>
          </el-button>
        </div>
        <div class="send-item">
          <span class="name">验证码</span>
          <div class="send-code-box">
            <el-input placeholder="请输入验证码" :maxlength="6" type="text" auto-complete="off" v-model.trim="authCode">
            </el-input>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="handleSure" :disabled="!authCode">确定 </el-button>
      </div>
    </el-dialog>

    <div id="letter-viewer">
      <img :src="urlPrefix + certificateInfo.engagementLetterUrl" alt="委托书" style="display: none" />
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:11
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import { WUYI, vali } from '@/api/common';
import axiosNew from '@/api/axiosNew';
import newApi from '@/api/settings.new.api';
import upLoadSinglePic from '@/components/UploadSinglePic';
import { getFileUrlPrefix } from '@/utils';
import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';
export default {
  components: {
    upLoadSinglePic
  },
  data() {
    return {
      urlPrefix: '',
      certificateInfo: {},
      identityCard: '',
      certificateStatus: 0, //认证状态 0未认证 1审核中 2审核未通过 3已认证 4待更新 5更新审核中 6更新审核不通过 99未升级
      accountCertificateStatus: 0, //实名认证0未认证1已认证
      isCorp: 1, // 管理员是否是法人本人1是 2否
      uploadTip: false,
      engagementLetterUrl: '', // 委托书图片
      validPhoneTip: false,
      userPhone: WUYI.currentData.user.usermobile,
      authCode: '',
      letterViewer: '',
      timer: null,
      countdown: {
        first: false,
        issend: false,
        second: 60
      }
    };
  },
  async created() {
    this.urlPrefix = await getFileUrlPrefix();
    this.fetchData();
  },
  methods: {
    fetchData() {
      axiosNew.post(newApi.qryManagerinfo).then(res => {
        this.certificateInfo = res.data;
        this.certificateStatus = res.data.certificateStatus;
        this.isCorp = res.data.corp;
        this.accountCertificateStatus = res.data.accountCertificateStatus;
      });
    },
    // 委托书下载
    handleDownload() {
      axiosNew.post(newApi.proxyStatementUrl).then(res => {
        window.location.href = this.urlPrefix + res.data.downloadUrl;
      });
    },
    // 上传委托书
    handleUploadLetter() {
      axiosNew.post(newApi.proxyStatement, { proxyStatementPhoto: this.engagementLetterUrl }).then(res => {
        this.uploadTip = false;
        this.fetchData();
      });
    },
    handleView() {
      this.validPhoneTip = true;
    },
    hanldeUpload() {
      this.uploadTip = true;
    },
    handleLoadSucceed(currentImgObj, cb) {
      const { name, url } = currentImgObj.data;
      const picSource = `${currentImgObj.source}`;
      this[picSource] = url;
      if (cb) cb();
    },
    handleRemoved(picSource) {
      this[picSource] = '';
    },
    //倒计时
    countDown: function () {
      var _this = this;
      if (this.countdown.second == 0) {
        this.countdown.issend = false;
        this.countdown.second = 60;
      } else {
        this.countdown.second--;
        this.timer = setTimeout(function () {
          _this.countDown();
        }, 1000);
      }
    },
    getCode() {
      if (this.countdown.issend) return;
      axiosNew.post(newApi.letterSend, { mobile: this.userPhone }).then(res => {
        this.countdown.issend = true;
        this.countDown();
      });
    },
    handleCloseValidPhoneTip() {
      this.validPhoneTip = false;
      clearTimeout(this.timer);
      this.authCode = '';
      this.countdown.issend = false;
      this.countdown.second = 60;
    },
    handleSure() {
      axiosNew
        .post(newApi.letterValidate, {
          mobile: this.userPhone,
          authCode: this.authCode
        })
        .then(res => {
          this.handleCloseValidPhoneTip();
          this.showViewer();
        });
    },
    showViewer() {
      const dom = document.getElementById('letter-viewer');
      this.letterViewer = new Viewer(dom);
      this.letterViewer.show();
      dom.addEventListener('hidden', () => {
        this.letterViewer.destroy(); // 关闭时销毁实例
      });
    },
    handleSetAdmin() {
      this.$router.push({ path: '/updateAdmin' });
    },
    handleToUpdateInfo() {
      this.$router.push({ path: '/adminInfoUpdate' });
    }
  }
};
</script>

<style scoped>
.segment-item-box {
  margin: 40px 20px;
}
.segment-item {
  display: flex;
  margin: 20px 0;
}
.segment-item .name {
  width: 164px;
  color: #90a0b1;
}
.segment-item .name.short {
  width: 100px;
}
.download {
  display: inline-block;
  margin-bottom: 10px;
}
.segment-item .dec {
  color: #424b53;
}
.rz-title i {
  display: inline-block;
  vertical-align: middle;
}

.red {
  color: #f35756;
}
.c9 {
  color: #999;
}

.send-box {
  margin: 10px 0 0 5px;
}
.sen-dec {
  color: #58626b;
}
.send-item {
  display: flex;
  align-items: center;
  margin: 10px 0;
}
.send-item .name {
  width: 60px;
  color: #90a0b1;
}
.send-item .dec {
  color: #58626b;
}
.send-code-box {
  width: 288px;
  position: relative;
  overflow: hidden;
}
.code-btn {
  padding: 10px 5px;
  background: none;
  border: none;
  color: #3399ff;
  height: 30px;
}
</style>
